import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  tradeId: Yup.string().required('fields.requiredField'),
  apiKey: Yup.string().required('fields.requiredField'),
  accountId: Yup.string().required('fields.requiredField'),
});
